import axios from 'api/axios'

export interface PulseReleaseData {
	pulseVersion: string
	apkUrl: string
	description: string
}

export const getPulseRelease = async (): Promise<PulseReleaseData> => {
	const { data } = await axios.get<PulseReleaseData>('api/pulse/release')
	return data
}

export const updatePulseRelease = async (
	body: Partial<PulseReleaseData>
): Promise<PulseReleaseData> => {
	const { data } = await axios.patch<PulseReleaseData>('api/pulse/release', body)
	return data
}
